var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B9EA",
    d: "m8.315 2.772 5.543 5.543-5.543 5.543-.981-.981 3.98-3.969-8.542.1V7.815h8.541s-3.684-4-3.98-4.062.982-.981.982-.981"
  })));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMzE0NjIgMi43NzE2TDEzLjg1NzcgOC4zMTQ2N0w4LjMxNDYyIDEzLjg1NzhMNy4zMzM1IDEyLjg3NjZMMTEuMzEzMiA4LjkwODQxTDIuNzcxNTQgOS4wMDc1NkwyLjc3MTU0IDcuODE0NjZMMTEuMzEzMiA3LjgxNDY2QzExLjMxMzIgNy44MTQ2NiA3LjYyOTE4IDMuODE0NjYgNy4zMzM1IDMuNzUyNzJDNy4wMzc4MSAzLjY5MDc4IDguMzE0NjIgMi43NzE2IDguMzE0NjIgMi43NzE2WiIgZmlsbD0iIzAwQjlFQSIvPgo8L3N2Zz4K";